import { createI18n } from 'vue-i18n'
import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'

const messages = Object.fromEntries(Object.entries(import.meta.glob('./locales/*.json', { eager: true }))
  .map(([key, value]) => [key.slice(10, -5), value.default]))

/**
 * Polish plural rules: 1 -> form 0, 2-4 (except 12-14) -> form 1, the rest -> form 2.
 * vue-i18n calls this function only for messages written with forms separated by "|".
 */
const polishPluralRule = (choice, choicesLength) => {
  if (choicesLength < 3) return choice === 1 ? 0 : 1

  const count = Math.abs(choice)
  if (count === 1) return 0

  const mod10 = count % 10
  const mod100 = count % 100

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1

  return 2
}

let _i18n = null
export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef('language', themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: 'en',
      messages,
      pluralRules: {
        pl: polishPluralRule,
      },
    })
  }
  
  return _i18n
}
export default function (app) {
  app.use(getI18n())
}
